import type { LoginThrottleStatusDTO } from "@pentacode/core";

export interface LoginThrottleStatusView {
    text: string;
    /** Whether there is a lock or a counter that a reset would remove. */
    resettable: boolean;
}

/**
 * The lock and the counter are separate Redis keys, so a lock can exist without counted attempts.
 * The lock decides what the admin sees and whether there is something to reset.
 */
export function describeLoginThrottleStatus(status: LoginThrottleStatusDTO): LoginThrottleStatusView {
    if (status.locked) {
        const text =
            status.lockSecondsRemaining >= 60
                ? `Konto ist noch ${Math.ceil(status.lockSecondsRemaining / 60)} Min. gesperrt.`
                : `Konto ist noch ${status.lockSecondsRemaining} Sek. gesperrt.`;
        return { text, resettable: true };
    }
    if (status.hasFailedAttempts) {
        return { text: "Fehlversuche gezählt, keine aktive Sperre.", resettable: true };
    }
    return { text: "Keine Fehlversuche erfasst, Konto ist nicht gesperrt.", resettable: false };
}
